import { isValidElement, useMemo, type ComponentProps, type ReactNode } from 'react';
import { CopyButton } from '../CopyButton';

// Recursively collect the text of a React subtree - used to recover the raw
// source of a Shiki-highlighted code block (tokens are nested <span>s) so the
// copy button has something to write.
function nodeText(node: ReactNode): string {
  if (node === null || node === undefined || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(nodeText).join('');
  if (isValidElement(node)) return nodeText((node.props as { children?: ReactNode }).children);
  return '';
}

/** Overrides the MDX `pre` tag to add a hover copy button over fenced code. */
export const Pre = ({ children, ...props }: ComponentProps<'pre'>) => {
  const code = useMemo(() => nodeText(children), [children]);
  return (
    <div className="group relative my-5">
      <CopyButton
        value={code}
        label="Copy"
        className="absolute right-2 top-2 z-10 opacity-0 transition-opacity group-hover:opacity-100"
      />
      <pre {...props}>{children}</pre>
    </div>
  );
};
